
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';


@Component({
    selector: 'app-activity-create-activity-pop-up',
    templateUrl: './activity-create-activity-pop-up.component.html',
    styleUrls: ['./activity-create-activity-pop-up.component.scss'],
    standalone: false
})
export class ActivityCreateActivityPopUpComponent implements OnInit {
	
	@Output() public popupVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	private _popupVisible: boolean = false;
	@Input()
	public set popupVisible(value: boolean) {
		this._popupVisible = value;

		this.popupVisibleChange.emit(this._popupVisible);
	}
	public get popupVisible(): boolean {
		return this._popupVisible;
	}
	
	public show() {
			this.popupVisible = true;
	}

	public hide() {
		this.popupVisible = false;
	}

	@Input() public title: string;
	
	@Input() public primaryButtonText: string = "Proceed";
	@Output() public onPrimaryButtonClicked: EventEmitter<any> = new EventEmitter<any>();

	@Input() public primaryLabel: string;
	@Input() public primaryValue: string;

	@Input() public secondaryLabel: Date | number | string;
	@Input() public secondaryValue: Date | number | string;

	@Input() public tetriaryLabel: string;
	@Input() public tetriaryValue: string;
	@Input() public tetriaryItems: string[];

	// public isInformationEnough: boolean = true;

	// @Output() public onSuccess: EventEmitter<any> = new EventEmitter<any>();

	// @Input() public popUpAction: "create" | "clone" | "clone-list";

	// @Input() public argument1: any;

	constructor(
		// private notificationService: NotificationService,
		// private forecastService: ForecastService,
	) {}

	ngOnInit() {
	}
	
	public onPrimaryButtonClick() {
		this.onPrimaryButtonClicked.emit({ primaryValue: this.primaryValue, secondaryValue: this.secondaryValue, tetriaryValue: this.tetriaryValue });
	}
}
